import { useEffect, useRef } from 'react';
export const useEffectOnce = effect => {
  const didRun = useRef(false);
  const effectRef = useRef(effect);
  useEffect(() => {
    if (didRun.current) {
      return;
    }
    didRun.current = true;
    const cleanup = effectRef.current();
    return () => {
      // run cleanup of the effect if it returned a cleanup function
      if (cleanup) {
        cleanup();
      }
    };
  }, []);
};